module.exports = __webpack_public_path__ + "img/landing-1-hr-HR.4e7b870.png";